import React, { FC, useState } from "react";
import { Container, List, ListItemButton, ListItemText } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { motion, AnimatePresence } from "framer-motion";
import { NavigationConfig } from "./types/navigationConfigType";
import NavigationMenuItem from "./NavigationMenuItem";
import NavigationItem from "./NavigationItem";

interface TopNavigationMenuProps {
  navConfig: NavigationConfig;
}

const TopNavigationMenu: FC<TopNavigationMenuProps> = ({ navConfig }) => {
  const [open, setOpen] = useState(false);

  const resetNavMenu = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen((prev) => {
      const next = !prev;
      if (next) {
        setTimeout(() => {
          window.addEventListener("click", resetNavMenu, { once: true });
        });
      }
      return next;
    });
  };

  return (
    <Container
      id="topNavigationMenuContainer"
      component={motion.div}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      {navConfig.subLinks ? (
        <List sx={{ pl: 0 }}>
          <ListItemButton
            onClick={handleOpen}
            className={`topNavigationMenuContent ${open ? "selected" : ""}`}
            component={motion.button}
            whileHover={{ x: 2 }}
            whileTap={{ scale: 0.98 }}
          >
            <ListItemText primary={navConfig.title} />
            <motion.span
              initial={false}
              animate={{ rotate: open ? 180 : 0 }}
              transition={{ duration: 0.25 }}
            >
              {open ? (
                <ExpandLess data-testid="ExpandLessIcon" />
              ) : (
                <ExpandMore data-testid="ExpandMoreIcon" />
              )}
            </motion.span>
          </ListItemButton>
          <AnimatePresence>
            {open && (
              <NavigationMenuItem
                key="dropdown-menu"
                navigations={navConfig.subLinks}
                close={resetNavMenu}
              />
            )}
          </AnimatePresence>
        </List>
      ) : (
        <NavigationItem navConfig={navConfig} />
      )}
    </Container>
  );
};

export default TopNavigationMenu;
